import React from "react";
import classnames from "classnames";
import {
  Button,
  Collapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  NavbarBrand,
  Navbar,
  Nav,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Col,
  ModalFooter
} from "reactstrap";
import { NavLink, Redirect } from 'react-router-dom'
import rest from '../../lib/rest'
import rotas from '../../services/rotas'
import Swal from 'sweetalert2'
import axios from 'axios'
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import "./AdminNavbar.css";

var interval;
var intervalNotificacao;

class AdminNavbar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      collapseOpen: false,
      color: "navbar-transparent",
      redirectToLogin: false,
      hiddenIntegracao: true,
      isPaneOpenLeft: false,
      tituloNotificacao: '',
      htmlNotificacao: '',
      intervaloNotificacao: 0,
      modalNotificacao: false,
    };
  }

  verificaIntegracao = () => {
    let lista = []
    const url = rotas.lojas
    const today = new Date();
    const date = today.getFullYear() + '-' + (today.getMonth() + 1).toString().padStart(2, "0") + '-' + today.getDate();
    const time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
    const agora = date + ' ' + time;

    try {
      const retorno = rest.get(url)
      retorno.then(ret => {
        if (ret.success === 'S') {
          ret.lista.forEach(loja => {
            let diferenca_integracao = (new Date(agora) - new Date(loja.final_integracao))
            let diferenca_paralela = (new Date(agora) - new Date(loja.final_paralela))

            diferenca_integracao = ((diferenca_integracao / 1000) / 60);
            diferenca_paralela = ((diferenca_paralela / 1000) / 60);

            if ((diferenca_integracao > 20) || (diferenca_paralela > 20)) {
              const estado = this.state;
              estado.hiddenIntegracao = false;

              this.setState(estado);
            }
          })
        }
      })
      return (lista)
    } catch (err) {
      console.log(err);
    }
  }

  logout = () => {
    sessionStorage.removeItem('token')
    this.setState({ redirectToLogin: true })
  }

  bloqueio = () => {
    sessionStorage.removeItem('token')

    const form = {
      usuario: sessionStorage.getItem('usuario'),
      cpf: sessionStorage.getItem('cpf'),
      senha: ''
    }

    Swal.fire({
      title: 'Sessão Bloqueada',
      html: `Usuário <b>${form.usuario}</b>.<br> Digite a senha para logar novamente.
      <input type="password" id="password" class="swal2-input" placeholder="Digite sua senha">`,
      confirmButtonText: 'Logar',
      showCancelButton: true,
      cancelButtonText: 'Sair',
      focusConfirm: false,
      showLoaderOnConfirm: true,
      allowEscapeKey: false,

      preConfirm: () => {
        form.senha = Swal.getPopup().querySelector('#password').value
        if (!form.senha) {
          Swal.showValidationMessage(`Por favor insira a senha`)

        } else {
          const url = rotas.login
          const logar = axios.post(url, form)

          return logar.then(ret => {
            if (ret.data.erro === "sim") {
              Swal.showValidationMessage('Senha inválida !!')

            } else {
              sessionStorage.setItem('token', ret.data.token)
              sessionStorage.setItem('rede', ret.data.rede)
              sessionStorage.setItem('usuario', ret.data.usuario)
              sessionStorage.setItem('cpf', ret.data.cpf)
            }
          })
        }
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {

      if (result.isConfirmed) {
        Swal.fire('Login efetuado com sucesso!', '', 'success')
      } else if (result.isDenied) {
        Swal.fire('erro no login!', '', 'error')
      } else if (result.dismiss) {
        sessionStorage.removeItem('token')
        this.setState({ redirectToLogin: true })
      }
    })
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateColor);

    interval = setInterval(() => { this.verificaIntegracao() }, 60000);

    intervalNotificacao = setInterval(() => { this.verificarNotificacao() }, 60000);

    this.verificarNotificacao(true)
  }

  componentDidUpdate(e) {
    if (
      window.outerWidth < 993 &&
      e.history.location.pathname !== e.location.pathname &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
    }
  }

  componentWillUnmount() {
    clearInterval(interval);
    clearInterval(intervalNotificacao);
    window.removeEventListener('resize', this.updateColor);
  }

  // function that adds color white/transparent to the navbar on resize (this is for the collapse)
  updateColor = () => {
    if (window.innerWidth < 993 && this.state.collapseOpen) {
      this.setState({
        color: "bg-white"
      });
    } else {
      this.setState({
        color: "navbar-transparent"
      });
    }
  };

  // this function opens and closes the sidebar on small devices
  toggleSidebar = () => {
    document.documentElement.classList.toggle("nav-open");
  };

  // this function opens and closes the collapse on small devices
  // it also adds navbar-transparent class to the navbar when closed
  // ad bg-white when opened
  toggleCollapse = () => {
    let newState = {
      collapseOpen: !this.state.collapseOpen
    };

    if (!this.state.collapseOpen) {
      newState["color"] = "bg-white";
    } else {
      newState["color"] = "navbar-transparent";
    }

    this.setState(newState);
  };

  verificarNotificacao = (modal) => {



  if(modal === undefined){
    modal = false;
  }



    const url = rotas.notificacoes
    const retorno = rest.get(url)
    retorno.then(ret => {
      if (ret.success === 'S') {
        let tItervalo = this.state.intervaloNotificacao;

        if (ret.lista.length > 0) {

          let estado = this.state;

          estado.isPaneOpenLeft=!modal;
              estado.tituloNotificacao= ret.lista[0].titulo;
              estado.htmlNotificacao= ret.lista[0].mensagem;
              estado.intervaloNotificacao= ret.lista[0].intervalo_notificacao;
              estado.modalNotificacao= modal

          //exibe da notificacao em um modal quando o usuario loga
             this.setState(estado)

              console.log( this.state);

            if ((ret.lista[0].intervalo_notificacao > 0) &&
              (ret.lista[0].intervalo_notificacao !== tItervalo)) {

              clearInterval(intervalNotificacao);
              intervalNotificacao = setInterval(() => {
                this.verificarNotificacao()
              }, ret.lista[0].intervalo_notificacao * 1000);
            }
          
        }
      }
    })
  }

  render() {
    if (this.state.redirectToLogin) {
      return <Redirect to='/painelwebgestor/auth/login' />
    }

    const rede = sessionStorage.getItem('rede');

    return (
      <>
        <Navbar
          className={classnames("navbar-absolute fixed-top", this.state.color)}
          expand="lg"
        >
          <Modal
            isOpen={this.state.modalNotificacao}
          >
            <ModalHeader>{this.state.tituloNotificacao}</ModalHeader>
            <ModalBody>
              <Row>
                <Col dangerouslySetInnerHTML={{__html: this.state.htmlNotificacao}}></Col>
              </Row>
            </ModalBody>

            <ModalFooter>
              <Row>
                <Col className="mr-2">                
                  <Button className="bg-danger" onClick={() => { this.setState({modalNotificacao:false}) }}>Fechar</Button>
                </Col>
              </Row>

            </ModalFooter>
          </Modal>
          <Container fluid>
            <div className="navbar-wrapper">

              {/* Abertura e fechamento da Sidebar */}
              <div className="navbar-minimize">
                <Button
                  outline
                  id="minimizeSidebar"
                  className="btn-round btn-icon"
                  color="primary"
                  onClick={this.props.handleMiniClick}
                >
                  <i className="fas fa-angle-double-right visible-on-sidebar-mini" />
                  <i className="fas fa-angle-double-left visible-on-sidebar-regular" />
                </Button>
              </div>
              {/* Fim */}

              <div
                className={classnames("navbar-toggle", {
                  toggled: this.state.sidebarOpen
                })}
              >
                <button
                  className="navbar-toggler"
                  type="button"
                  onClick={this.toggleSidebar}
                >
                  <span className="navbar-toggler-bar bar1" />
                  <span className="navbar-toggler-bar bar2" />
                  <span className="navbar-toggler-bar bar3" />
                </button>
              </div>
              <NavbarBrand>
                <span className="d-none d-md-block">
                  {'REDE ' + rede}
                </span>
              </NavbarBrand>

              <NavLink to="lojas" activeClassName="" >
                <div
                  hidden={this.state.hiddenIntegracao}
                  className="text-center icon-warning"
                >
                  <i className="text-warning fas fa-exclamation-triangle" style={{ fontSize: '1.8rem' }}></i>
                  <p className="h4 ml-3">Existem lojas com integração parada!</p>
                </div>
              </NavLink>

            </div>
            <button
              aria-controls="navigation-index"
              aria-expanded={this.state.collapseOpen}
              aria-label="Toggle navigation"
              className="navbar-toggler"
              data-toggle="collapse"
              type="button"
              onClick={this.toggleCollapse}
            >
              <span className="navbar-toggler-bar navbar-kebab" />
              <span className="navbar-toggler-bar navbar-kebab" />
              <span className="navbar-toggler-bar navbar-kebab" />
            </button>
            <Collapse
              navbar
              className="justify-content-end"
              isOpen={this.state.collapseOpen}
            >
              <Nav navbar>
                {/* <UncontrolledDropdown className="btn-rotate" nav>
                  <DropdownToggle
                    aria-haspopup={true}
                    caret
                    color="default"
                    data-toggle="dropdown"
                    id="navbarDropdownMenuLink"
                    nav
                  >
                    <i className="far fa-bell" />
                    <p>
                      <span className="d-lg-none d-md-block">Notificações</span>
                    </p>
                  </DropdownToggle>
                  <DropdownMenu aria-labelledby="navbarDropdownMenuLink" right>
                    <DropdownItem
                      href=""
                      onClick={e => e.preventDefault()}
                    >
                      Notificações
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown> */}

                <UncontrolledDropdown className="" nav>
                  <DropdownToggle
                    nav
                    caret
                    id="navbarDropdownMenuLink"
                    aria-haspopup={true}
                    color="default"
                    data-toggle="dropdown"
                  >
                    <i className="fas fa-walking" />
                    <p>
                      <span className="d-lg-none d-md-block">Sair</span>
                    </p>
                  </DropdownToggle>
                  <DropdownMenu aria-labelledby="navbarDropdownMenuLink" right>
                    <DropdownItem
                      href=""
                      onClick={e => {
                        e.preventDefault()
                        this.bloqueio()
                      }}
                    >
                      Bloquear
                    </DropdownItem>
                    <DropdownItem
                      href=""
                      onClick={e => {
                        e.preventDefault()
                        this.logout()
                      }}
                    >
                      Sair
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </Nav>
            </Collapse>
            <SlidingPane
              width="400px"
              className="popup-manutencao"
              overlayClassName="some-custom-overlay-class"
              isOpen={this.state.isPaneOpenLeft}
              title={this.state.tituloNotificacao}
              closeIcon={<i class="fa fa-close" aria-hidden="true"></i>}
              // subtitle="Optional subtitle."
              onRequestClose={() => {
                // triggered on "<" on left top click or on outside click
                this.setState({ isPaneOpenLeft: false });
              }}
            >
              <div
                dangerouslySetInnerHTML={{ __html: this.state.htmlNotificacao }}
              ></div>
              {/* <img src="http://127.0.0.1/img/manutencao.jpg" /> */}
            </SlidingPane>
          </Container>
        </Navbar>
      </>
    );
  }
}

export default AdminNavbar;
